import React from "react";

import { useOrgModParams } from "src/features/orgmod";
import { StatusChart as BasicHealthStatusChart } from "src/modules/basic-health";
import { StatusChart as HtxStatusChart } from "src/modules/htx";
import { StatusChart as KtxStatusChart } from "src/modules/ktx";
import { StatusChart as LtxStatusChart } from "src/modules/ltx";

export const StatusChart: React.FunctionComponent = () => {
	const { mod } = useOrgModParams();
	if (mod === "htx" || mod === "htx_nm") {
		return <HtxStatusChart />;
	}
	if (mod === "ktx" || mod === "kd") {
		return <KtxStatusChart />;
	}
	if (mod === "basic_health") {
		return <BasicHealthStatusChart />;
	}
	if (mod === "ltx") {
		return <LtxStatusChart />;
	}
	return null;
};
